import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiEpBillingSplit {
}
ApiEpBillingSplit.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/billing/v1/split/`,
    method: "GET",
    next: req.next,
    query: req.query,
});
//# sourceMappingURL=split.js.map